<template>
  <div class="selection-footer">
    <div class="footer-contact">
      <b>联系我们，为企业加速</b>
      <el-input
        placeholder="请输入内容"
        v-model="value"
        class="input-with-select"
      >
        <el-button slot="append" type="" @click="submit">马上联系</el-button>
      </el-input>
    </div>

    <div class="c-container">
      <div class="footer-content">
        <el-row :gutter="20">
          <el-col class="item" :md="6" :xs="8">
            <b>产品</b>
            <p
              @click="proDetail(item)"
              v-for="item in productList"
              :key="item.id"
            >
              {{ item.menuTitle }}
            </p>
          </el-col>
          <el-col class="item" :md="6" :xs="8">
            <b>智能系统</b>
            <p
              @click="proSystem(item)"
              v-for="item in systemList"
              :key="item.id"
            >
              {{ item.menuTitle }}
            </p>
          </el-col>
          <el-col class="item" :md="6" :xs="8">
            <b>关于智起云</b>
            <p
              @click="aboutPage"
              v-for="item in aboutList"
              :key="item.menuTitle"
            >
              {{ item.menuTitle }}
            </p>
          </el-col>
          <el-col class="item last-item" :md="6" :xs="24">
            <b>全国服务热线</b>
            <div>
              <b>{{ aboutInfo.phone }}</b>
            </div>
            <p>周一到周五：9:00-19:00</p>
            <p>周六：9:00-17:30</p>
            <div class="ercode-b">
              <div class="wexin">
                <img :src="aboutInfo.wethatImgUrl" alt="" />
                <div>
                  <p>{{ aboutInfo.wethatName }}</p>
                </div>
              </div>
              <div class="wexin">
                <img :src="aboutInfo.appletImgUrl" alt="" />
                <div>
                  <p>{{ aboutInfo.appletName }}</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="c-container">
      <div class="bottom-base">
        <hr />
        <div class="base-b">
          <div class="base-r">
            <p>法律声明</p>
            <p>
              {{ aboutInfo.copyrightContent }}
              <a href="https://beian.miit.gov.cn/" target="_blank">{{
                aboutInfo.filingsInfo
              }}</a>
            </p>
            <p>技术支持：深圳市智起网络科技有限公司</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      productList: [],
      systemList: [],
      aboutInfo: {},
      aboutList: [
        { menuTitle: "智起云介绍" },
        { menuTitle: "联系我们" },
        { menuTitle: "加入我们" },
        { menuTitle: "业务动态" }
      ]
    };
  },
  created() {
    this.getproInfo();
    this.getSystemInfo();
    this.getAbourInfo();
  },
  methods: {
    aboutPage() {
      this.$router.push({
        path: "/aboutUs"
      });
    },
    proDetail(item) {
      this.$router.push({
        path: "/smartProduct",
        query: {
          id: item.id
        }
      });
    },
    proSystem(item) {
      this.$router.push({
        path: "/smartSystem",
        query: {
          id: item.id
        }
      });
    },
    submit() {
      if (this.value) {
        this.$api.other.leaveFormSubmit({ mobile: this.value }).then(res => {
          this.$message.info("提交成功");
        });
      } else {
        this.$message.info("请输入手机号");
      }
    },
    getAbourInfo() {
      this.$api.other.aboutUsShow().then(res => {
        this.aboutInfo = res.data;
      });
    },
    getSystemInfo() {
      this.$api.smartSystem.systemList().then(res => {
        this.systemList = res.data.list;
      });
    },
    getproInfo() {
      this.$api.productManagement.proList().then(res => {
        this.productList = res.data.list;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.selection-footer {
  background: #0b054a;

  .footer-contact {
    padding: 20px;
    height: 153px;
    background: #409eff;
    font-size: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #fff;
    flex-wrap: wrap;
    .el-input {
      max-width: 300px;
    }
  }
  .footer-content {
    padding: 40px 20px;
    .item {
      flex: 1;
      b {
        color: #ccc;
        font-size: 18px;
        margin-bottom: 20px;
        display: inline-block;
      }
      p {
        font-size: 14px;
        color: #ccc;
        opacity: 0.7;
        padding-bottom: 10px;
        cursor: pointer;
      }
    }
    .last-item {
      margin-top: 30px;
      .ercode-b {
        display: flex;
        img {
          width: 100px;
          height: 100px;
          border-radius: 5px;
        }
        .wexin {
          margin-right: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          p {
            margin-top: 20px;
          }
        }
      }
    }

    @media screen and(min-width: 768px) {
      .last-item {
        margin-top: 0px;
      }
    }
  }
  .bottom-base {
    padding: 20px;
    background: #0b054a;
    color: #ccc;
    hr {
      opacity: 0.4;
      margin-bottom: 20px;
    }
    p {
      font-size: 12px;
      opacity: 0.7;
    }
    .base-b {
      text-align: center;
      .base-r {
        line-height: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerMes/index.vue